<template>

<div class="profile-component">

	<top-bar></top-bar>

	<div id="user-profile" class="container">
		<p><b>Name:</b> {{$store.state.auth.username}}</p>
		<p><b>Administrator status:</b> {{$store.state.auth.superuser}}</p>
		<p><b>Roles:</b></p>
		<ul v-for="role in roles">
			<li>{{role}}</li>
		</ul>

	</div>
</div>

</template>
<script type="text/javascript">
	import TopBar from './TopBar.vue'
	export default {
		components: {
			'top-bar': TopBar
		},
		computed: {
			roles(){
				var roles = this.$store.state.auth.roles

				return roles.split(',')
			}
		}
	}
</script>
